import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseAccess() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const UserPermissionsPermit = (bool) => {
    MyAxios.get(`Admin_Permissions/UserPermissionsPermit`, {
      headers: {
        IsPage: bool,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
      }
    });
  };

  const getAllUserPermissions = (selectedId, callback) => {
    MyAxios.get(`Admin_Permissions/${selectedId}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        let pageList = getPageList(response.data.resault);
        let pageStateList = getPageStateList(pageList);

        callback(response.data.resault, pageList, pageStateList);
      }
    });
  };

  const Remove = (selectedId, callback) => {
    const data = new FormData();
    data.append("UserID", JSON.stringify(selectedId));
    MyAxios.delete(`Admin_Permissions`, {
      data: data,
    }).then((response) => {
      if (response && response.data.state && response.data.state == 200) {
        enqueueSnackbar("سطوح دسترسی با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const setUserPermissions = (test2, selectedId, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(test2));
    data.append("UserID", JSON.stringify(selectedId));

    MyAxios.post(`Admin_Permissions`, data).then((response) => {
      if (response && response.data.state && response.data.state == 200) {
        enqueueSnackbar("سطح دسترسی با موفقیت بروزرسانی شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  function getPageList(permissions) {
    var tempList = [];
    permissions.map((gp) => {
      tempList.push.apply(tempList, gp.pages);
    });
    return tempList;
  }

  function getPageStateList(pageList) {
    var tempList = [];
    pageList.map((pageElem) => {
      tempList.push({
        pageId: pageElem.id,
        isPermit: pageElem.isPermit,
        title: pageElem.title,
      });
    });

    return tempList;
  }

  return {
    getAllUserPermissions,
    Remove,
    setUserPermissions,
    UserPermissionsPermit,
  };
}
